var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"https://i.imgur.com/pd04s14.jpg","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }